(ns ycweb.app.admin.tasks.forms.task
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.admin.tasks.common :as yaatc.common]
   [ycweb.app.dashboard.common :as dcommon]
   [ycweb.app.dashboard.presence :as presence]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.util.comms :as comms]
   [ycweb.components.headings :as headings]
   [ycweb.components.datepicker :as datepicker]
   [ycweb.components.richeditor :as richeditor]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.transitions :as t]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

(defmethod grid/action :admin.tasks/close-task-view [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        selected-task (cmn/curact process-atom [:selected-task :task])]
    (swap! app-atom update :admin.tasks
      (fn [process]
        (->
          process
          (update :broadcast-tasks dissoc (:ent/uuid selected-task))
          (dissoc :selected-task))))
    (urlstate/redirect app-atom "tasks" nil
      (dissoc (cmn/screen-params app-atom) :task-uuid))))

(defmethod grid/action :admin.tasks/save-task [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        task (get-in @process-atom [:selected-task :task])]

    #_(swap! (cmn/process-cursor app-atom) assoc-in [:tasks (:ent/uuid task)] task)
    #_(comms/send :admin.tasks/save
        {:task (yaatc.common/reshape-task-save task)})

    (grid/dispatch-modal-action app-atom :admin.tasks/close-task-view {})))

(defmethod comms/receive :admin.tasks/save [app-atom {:keys [task] :as e}]
  (let [process-atom (cmn/process-cursor app-atom)
        selected-task (cmn/curact process-atom :selected-task)]

    (swap! (cmn/process-cursor app-atom) assoc-in [:tasks (:ent/uuid task)] task)

    (when (:msg e)
      (toaster/open-toast app-atom :success (:msg e) {}))

    (when (:task/new? (:task selected-task))
      (swap! process-atom assoc :selected-task {:task task :layout :modal})
      (urlstate/redirect app-atom "tasks" nil
        (assoc (cmn/screen-params app-atom) :task-uuid (:ent/uuid task))))))

(defmethod grid/action :admin.tasks/delete [app-atom config _]
  (grid/confirm-modal app-atom
    {:title "Delete Task"
     :text "Really delete this task?"
     :confirm-key :admin.tasks/delete-confirmed
     :cancel-key :admin.tasks/open-task
     :task (:task config)}))

(defmethod grid/action :admin.tasks/delete-confirmed [app-atom config _]
  (comms/send :admin.tasks/delete {:task {:ent/uuid (:ent/uuid (:task config))}})
  (toaster/open-toast app-atom :processing "Deleting" {}))

(defmethod comms/receive :admin.tasks/delete [app-atom e]
  (swap! (cmn/process-cursor app-atom) update :tasks dissoc (:ent/uuid e))
  (toaster/open-toast app-atom :success "Deleted!" {}))

(defmethod grid/action :admin.tasks/open-task [app-atom config _]
  (grid/open-modal app-atom :admin.tasks/task-view {}))

(defmethod grid/action :admin.tasks/new-task [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        new-task (yaatc.common/generate-new-task app-atom config)]

    (swap! process-atom assoc :selected-task {:task new-task :layout :modal})
    (grid/open-modal app-atom :admin.tasks/task-view {})))

(rum/defc top-buttons < rum/reactive cmn/cursors [app-atom task-atom branch-name]
  (let [task (rum/react task-atom)
        process-atom (cmn/process-cursor app-atom)
        broadcast-tasks (cmn/curact process-atom :broadcast-tasks)
        matching-task (get broadcast-tasks (:ent/uuid task))]
    [:div
     {:class (u/bem :flex-grid-group [:align-between :flush-force])}
     [:div
      {:class (u/bem :flex-grid-block [:fluid])}
      [:div.flex-grid-content
       (headings/heading "Task view" {:type :h1 :size :large})]]
     [:div
      {:class (u/bem :flex-grid-block [:fluid :align-left])}
      [:div.flex-grid-content
       (buttons/button-clipboard "Link"
         {:style :secondary-noborder
          :flat-style :flat}
         #(urlstate/current-url))
       (buttons/button-clipboard branch-name
         {:style :secondary-noborder
          :flat-style :flat}
         (fn [] branch-name))
       (buttons/button-web "Small view"
         (merge
           (urlstate/href-props app-atom "tasks" nil {:task-uuid (:ent/uuid task)})
           {:style :secondary-noborder
            :size :default
            :flat-style :flat
            :icon :arrow-collapse
            :icon-placement :right}))]]
     [:div
      {:class (u/bem :flex-grid-block [:fluid])}
      [:div.flex-grid-content
       [:div
        {:class (u/bem :flex-grid-group [:flush])}
        #_[:div
           {:class (u/bem :flex-grid-block [:fluid])}
           [:div.flex-grid-content
            (buttons/button-web "Save & close"
              {:style :primary
               :size :default
               :disabled (not (nil? matching-task))
               :on-click
               #(grid/dispatch-modal-action app-atom
                  :admin.tasks/save-task
                  {:task task})})]]
        [:div
         {:class (u/bem :flex-grid-block [:fluid])}
         [:div.flex-grid-content
          (buttons/button-web "Back"
            (merge
              (urlstate/href-props app-atom "tasks" nil {:task-uuid (:ent/uuid task)})
              {:style :secondary
               :size :default}))]]]]]]))

(defmethod grid/action :admin.tasks/accept-task-changes [app-atom {:keys [task-uuid]}]
  (let [process-atom (cmn/process-cursor app-atom)
        matching-task (cmn/curact process-atom [:broadcast-tasks task-uuid])]
    (swap! app-atom update :admin.tasks
      (fn [process]
        (->
          process
          (assoc-in [:selected-task :task] matching-task)
          (update :broadcast-tasks dissoc task-uuid))))))

(rum/defc task-form < rum/reactive cmn/cursors
  [app-atom task-atom branch-name lookup-atom task-lookup-atom people
   display-name-filter-pred teams view]
  (let [process-atom (cmn/process-cursor app-atom)
        task (rum/react task-atom)
        new-task? (cmn/curact task-atom [:task/new?])
        broadcast-tasks (cmn/curact process-atom :broadcast-tasks)
        matching-task (get broadcast-tasks (:ent/uuid task))]
    (list
      [:div
       {:class (u/bem :flex-grid-group [:flush-force :align-left])}

       (when matching-task
         [:div.flex-grid-block--1-1
          [:div.flex-grid-group
           [:div
            {:class (u/bem :flex-grid-block [:m-4-6])}
            [:div.flex-grid-content
             (feedback/feedback :warning
               "This task has been recently updated"
               "To ensure your changes aren't lost. Please make note of them, and accept the incoming changes")]]
           [:div
            {:class (u/bem :flex-grid-block [:m-1-6])}
            [:div.flex-grid-content
             (buttons/button "Accept Changes"
               #(grid/dispatch-action app-atom :admin.tasks/accept-task-changes
                  {:task-uuid (:ent/uuid task)}) {})]]]])
       [:div
        {:class (u/bem :flex-grid-block [:m-3-5])}
        [:div.flex-grid-content
         (cond
           (= view :page)
           [:div.form-field
            [:label.form-label
             "Task Title:"]

            (forms/input-raw "Task Title"
              (cmn/cursor-in task-atom [:ent/display-name])
              {:auto-focus true})]

           (= view :modal)
           (list
             [:label.form-label
              "Task Title:"]

             (forms/input-raw "Task Title"
               (cmn/cursor-in task-atom [:ent/display-name])
               {:auto-focus true
                :class :u-margin-bottom-8})))

         (when (and (not new-task?) (= view :modal))
           [:div.u-margin-bottom-10
            (buttons/button-clipboard "Link"
              {:style :secondary-noborder
               :flat-style :flat}
              #(urlstate/current-url))
            (buttons/button-clipboard branch-name
              {:style :secondary-noborder
               :flat-style :flat}
              (fn [] branch-name))
            (buttons/button-web "Large view"
              (merge
                (urlstate/href-props app-atom "tasks" "task" {:task-uuid (:ent/uuid task)})
                {:style :secondary-noborder
                 :size :default
                 :flat-style :flat
                 :icon :arrow-expand
                 :icon-placement :right}))])

         (forms/split-field
           ["Team:"
            (forms/inline-autocomplete-select
              [:div {:style {:padding-top "10px"}}
               (yaatc.common/status app-atom {} {} (cmn/curact task-lookup-atom :task/team))]

              teams
              {:select-style? true
               :select-fn #(swap! task-atom assoc :task/team %)
               :item-render-fn (partial yaatc.common/status app-atom {})
               :filter-fn display-name-filter-pred})
            {}]

           ["Product:"
            (forms/inline-autocomplete-select
              [:div {:style {:padding-top "10px"}}
               (yaatc.common/status app-atom {} {} (cmn/curact task-lookup-atom :task/product))]
              (->>
                (cmn/curact lookup-atom [:task.product])
                (vals)
                (sort-by :ent/sort-order))
              {:select-style? true
               :select-fn
               #(swap! task-atom assoc :task/product %)

               :item-render-fn (partial yaatc.common/status app-atom {})
               :filter-fn
               display-name-filter-pred})
            {:no-icon true}])

         (forms/split-field
           [(str "Requested: (" (ud/format-date (cmn/curact task-atom :airtable/date-created) "E, d MMM ''YY") ")")
            (forms/inline-autocomplete-select
              [:div {:style {:padding-top "14px"}}
               (yaatc.common/person-cell app-atom {} {} (cmn/curact task-lookup-atom :task/requestor))]

              people
              {:select-style? true
               :select-fn #(swap! task-atom assoc :task/requestor %)
               :item-render-fn (partial yaatc.common/person-cell app-atom {} {})
               :filter-fn
               display-name-filter-pred})
            {}]

           ["Assigned:"
            (forms/inline-autocomplete-select
              (into
                [:div {:style {:padding-top "8px" :overflow "hidden" :white-space "nowrap"}}]
                (->>
                  (vals (:task/assigned (rum/react task-atom)))
                  (filter #(:selected? %))
                  (map
                    #(yaatc.common/person-cell-selected app-atom {} {} %))))
              people
              {:select-style? true
               :force-open? true
               :initial-list
               (filter
                 #(= "Technology" (:staff/department %))
                 people)
               :select-fn
               #(grid/dispatch-action app-atom :admin.tasks/multi-select-update
                  {:entity-atom task-atom
                   :filter-selector :task/assigned
                   :item-selector :ent/uuid
                   :selected-key :selected?
                   :selected-item %})
               :item-render-fn
               (partial yaatc.common/person-cell-toggle app-atom (rum/cursor task-atom :task/assigned)
                 {:item-selector :ent/uuid
                  :selected-key :selected?})
               :filter-fn display-name-filter-pred})
            {:no-icon true}])

         (forms/split-field
           ["Team Status:"
            (forms/inline-autocomplete-select
              [:div {:style {:padding-top "10px"}}
               (yaatc.common/status app-atom {} {} (cmn/curact task-lookup-atom :task/team-status))]
              (->>
                (cmn/curact lookup-atom [:task.team-status])
                (vals)
                (sort-by :ent/sort-order))
              {:select-style? true
               :select-fn #(swap! task-atom assoc :task/team-status %)
               :item-render-fn (partial yaatc.common/status app-atom {})
               :filter-fn
               display-name-filter-pred})
            {}]
           ["Dev Status:"
            (forms/inline-autocomplete-select
              [:div {:style {:padding-top "10px"}}
               (yaatc.common/status app-atom {} {} (cmn/curact task-lookup-atom :task/dev-status))]
              (->>
                (cmn/curact lookup-atom [:task.dev-status])
                (vals)
                (sort-by :ent/sort-order))
              {:select-style? true
               :select-fn #(swap! task-atom assoc :task/dev-status %)
               :item-render-fn (partial yaatc.common/status app-atom {})
               :filter-fn
               display-name-filter-pred})
            {:no-icon true}])

         (forms/split-field
           ["Stream:"
            (forms/inline-autocomplete-select
              [:div {:style {:padding-top "10px"}}
               (yaatc.common/status app-atom {} {} (cmn/curact task-lookup-atom :task/stream))]
              (->>
                (cmn/curact lookup-atom [:task.stream])
                (vals))
              {:select-style? true
               :select-fn #(swap! task-atom assoc :task/stream %)
               :item-render-fn (partial yaatc.common/status app-atom {})
               :filter-fn display-name-filter-pred})
            {}]
           ["Type:"
            (forms/inline-autocomplete-select
              [:div {:style {:padding-top "10px"}}
               (yaatc.common/status app-atom {} {} (cmn/curact task-lookup-atom :task/type))]
              (->>
                (cmn/curact lookup-atom [:task.type])
                (vals)
                (sort-by :ent/sort-order))
              {:select-style? true
               :select-fn #(swap! task-atom assoc :task/type %)
               :item-render-fn (partial yaatc.common/status app-atom {})
               :filter-fn
               display-name-filter-pred})
            {:no-icon true}])

         (forms/split-field
           ["Budget:"
            (forms/inline-autocomplete-select
              [:div {:style {:padding-top "10px"}}
               (yaatc.common/status app-atom {} {} (cmn/curact task-lookup-atom :task/budget))]
              (->>
                (cmn/curact lookup-atom [:times])
                (sort-by first))
              {:select-style? true
               :select-fn
               #(swap! task-atom assoc :task/budget (first %))
               :item-render-fn (comp (partial yaatc.common/status app-atom {}) second)
               :filter-fn
               #(str/includes? (str/lower-case (second %)) (str/lower-case %))})
            {}]

           ["Time Spent:"
            (forms/inline-autocomplete-select
              [:div {:style {:padding-top "10px"}}
               (yaatc.common/status app-atom {} {} (cmn/curact task-lookup-atom :task/time-spent))]
              (->>
                (cmn/curact lookup-atom [:times])
                (sort-by first))
              {:select-style? true
               :select-fn
               #(swap! task-atom assoc :task/time-spent (first %))
               :item-render-fn (comp (partial yaatc.common/status app-atom {}) second)
               :filter-fn
               #(str/includes? (str/lower-case (second %)) (str/lower-case %))})
            {:no-icon true}])]]

       [:div
        {:class (u/bem :flex-grid-block [:m-2-5])}
        [:div.flex-grid-content
         (when-not new-task?
           (presence/presence-inline-chat app-atom (cmn/curact task-atom [:ent/uuid])))]]]

      (forms/form-field
        "Project:" {}
        (forms/inline-autocomplete-select
          [:div {:style {:padding-top "10px"}}
           (yaatc.common/status app-atom {} {}
             (let [project (cmn/curact task-lookup-atom :task/project)]
               (assoc project :ent/color (get-in project [:task-project/timing :ent/color]))))]
          (->>
            (cmn/curact lookup-atom [:task.project])
            (vals)
            (sort-by (juxt (comp :ent/sort-order :task-project/timing) :ent/display-name)))
          {:select-style? true
           :select-fn
           #(swap! task-atom assoc :task/project %)

           :item-render-fn
           (fn [project]
             (yaatc.common/status app-atom {} {}
               (assoc project :ent/color (get-in project [:task-project/timing :ent/color]))))
           :filter-fn
           display-name-filter-pred}))

      (forms/input "URLs:" "/admin/csprocess.htm?action=failedpaid"
        (cmn/cursor-in task-atom [:task/urls])
        {:hint "This is very helpful for solving the issue"})

      (forms/form-field
        "What:" {}
        (richeditor/inline-markdowneditor (cmn/cursor-in task-atom [:task/what])
          {}))

      (forms/form-field
        "Why:" {}
        (richeditor/inline-markdowneditor (cmn/cursor-in task-atom [:task/why])
          {}))
      (forms/form-field
        "Proposed solution:" {}
        (richeditor/inline-markdowneditor (cmn/cursor-in task-atom [:task/solution])
          {}))

      (forms/form-field
        "Deadline:" {}
        (datepicker/datepicker app-atom "" "Pick a hard deadline"
          [:admin.tasks :selected-task :task :task/date-deadline]
          {:datatype :datedmy}))

      (forms/form-field
        "Deadline risk: (consequences of not meeting the deadline)" {}
        (richeditor/inline-markdowneditor (cmn/cursor-in task-atom [:task/deadline-risk])
          {}))

      #_(when
          (= view :page)
          [:span.u-margin-right-10
           (buttons/button-web "Save & close"
             {:style :primary
              :size :default
              :disabled (not (nil? matching-task))
              :on-click
              #(grid/dispatch-modal-action app-atom
                 :admin.tasks/save-task
                 {:task task})})])

      #_(when-not new-task?
          (buttons/button-web "Delete task"
            {:style :negative
             :on-click
             #(grid/dispatch-action app-atom :admin.tasks/delete {:task task})})))))


(rum/defc task-body < rum/reactive cmn/cursors [app-atom modal-atom m-config]
  (let [view (:layout m-config)
        process-atom (cmn/process-cursor app-atom)
        lookup-atom (cmn/cursor-in process-atom [:lookup])

        selected-task-atom (rum/cursor-in process-atom [:selected-task :task])

        task-lookup-atom
        (yaatc.common/derived-lookup-task-atom selected-task-atom lookup-atom)
        display-name-filter-pred
        #(str/includes?
           (str/lower-case (:ent/display-name %1))
           (str/lower-case %2))


        teams
        (->>
          (cmn/curact lookup-atom :task.team)
          (vals)
          (sort-by :ent/display-name))

        people-atom (rum/cursor lookup-atom :user)
        people
        (->>
          (rum/react people-atom)
          (vals)
          (sort-by :ent/display-name))

        branch-name
        (yaatc.common/task-branch
          (cmn/curact-keys task-lookup-atom ::branch-name
            [:ent/uuid :task/team :ent/display-name]))]

    [:div
     (when
       (= view :page)
       (top-buttons app-atom selected-task-atom branch-name))
     (task-form app-atom selected-task-atom branch-name lookup-atom task-lookup-atom people display-name-filter-pred teams view)]))

(rum/defc task-modal-footer < rum/reactive [app-atom config-atom m-config]
  (let [process-atom (cmn/process-cursor app-atom)
        selected-task (cmn/curact process-atom [:selected-task :task])
        broadcast-tasks (cmn/curact process-atom :broadcast-tasks)
        matching-task (get broadcast-tasks (:ent/uuid selected-task))]
    (grid/button-row
      {:left-text "Close"
       :left-no-icon true
       :left-fn
       #(grid/dispatch-modal-action app-atom :admin.tasks/close-task-view)
       :right-text "Save"
       :right-no-icon true
       :right-disabled? true #_(not (nil? matching-task))
       :right-fn
       #(grid/dispatch-modal-action app-atom :admin.tasks/save-task)})))


(defmethod grid/modal-config :admin.tasks/task-view [app-atom config _]
  {:body task-body
   :layout :modal
   :footer task-modal-footer
   :cancel-key :admin.tasks/close-task-view
   :modal-type :details
   :max-width 920})

(rum/defc viewtask < rum/reactive cmn/cursors [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        task-atom (rum/cursor-in process-atom [:selected-task :task])]

    [:div
     (task-body app-atom task-atom {:layout :page})]))

(defmethod flow/render-screen :admin.tasks/task [app-atom _]
  (viewtask app-atom))

(defmethod t/transition-open :admin.tasks/task [app-atom _ params]
  (let [process-atom (cmn/process-cursor app-atom)
        task (cmn/curact process-atom [:selected-task :task])]

    (swap! process-atom assoc-in [:selected-task :layout] :page)
    (when (nil? task)
      (comms/send :admin.tasks/lookup {})
      (comms/send :admin.tasks/view {:task-uuid (:task-uuid params)}))
    (toaster/open-overlay app-atom :admin.tasks/task)))

(defmethod t/transition-after-open :admin.tasks/task [app-atom _]
  (dcommon/kill-search-bar)
  (let [process-atom (cmn/process-cursor app-atom)
        task (cmn/curact process-atom [:selected-task :task])]
    (when task
      (presence/open app-atom {:ent/uuid (:ent/uuid task) :context/type :task})
      (presence/open-inline-node app-atom {:ent/uuid (:ent/uuid task) :context/type :task}))))